import { render } from "./order_form.vue?vue&type=template&id=e3593626&scoped=true"
import script from "./order_form.vue?vue&type=script&lang=ts"
export * from "./order_form.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-e3593626"

export default script